module.exports = __webpack_public_path__ + "static/media/apartment19.449ab6ac.jpg";